import {
  Component,
  EventEmitter,
  Input,
  Output,
  input,
  output,
} from '@angular/core';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { TrackLinkDirective } from '@analytics/events';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { DefaultComponentModule } from '@innogy/core/modules/components';

import {
  CommodityOfferLabels,
  CommodityOfferLayoutType,
} from '../../commodity-offers.model';
import { CommodityOfferCardComponent } from '../../commodity-offer-card/commodity-offer-card.component';
import { CommodityOfferEssentHeaderComponent } from '../../partials/essent/commodity-offer-header/commodity-offer-header.component';
import { CommodityOfferAccordionComponent } from '../../commodity-offer-accordion/commodity-offer-accordion.component';
import { CommodityOfferUspListComponent } from '../../partials/shared/commodity-usp-list/commodity-usp-list.component';
import { RoundedCurrencyPipe } from '@innogy/utils-deprecated';

@Component({
  selector: 'essent-consumer-retention-minimal-commodity-offer',
  templateUrl:
    './essent-consumer-retention-minimal-commodity-offer.component.html',
  styleUrls: [
    'essent-consumer-retention-minimal-commodity-offer.component.scss',
  ],
  standalone: true,
  imports: [
    CommodityOfferCardComponent,
    CommodityOfferEssentHeaderComponent,
    CommodityOfferAccordionComponent,
    CSCaptureDirective,
    TrackLinkDirective,
    AutomationIdDirective,
    DefaultComponentModule,
    CommodityOfferUspListComponent,
    RoundedCurrencyPipe,
  ],
})
export class EssentConsumerRetentionMinimalCommodityOfferComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() offer?: Offer;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() content?: CommodityOfferLabels;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() variant?: CommodityOfferLayoutType;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() active = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showLoadingState = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() ensureHorizontalAlignment = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() enableNewOfferCardTitles = false;

  readonly isQuestionnaireVariant = input(false);
  readonly floatingIncentive = input(false);
  showQuestionnaireExplanation = output();

  @Output() selectOffer = new EventEmitter<void>();
  @Output() viewTariffs = new EventEmitter<void>();
  @Output() openMoreInfo = new EventEmitter<void>();
}
